export default "__VITE_ASSET__18ed55fd__"